import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { FileDownload } from 'ecs-react-components/dist/index.es';

import {
  setDownloadPath,
} from '../../redux/modules/health-summary/health-summary-middleware';

import { messages } from './HealthSummary.i18n';

function FileDownloadButton() {
  const dispatch = useDispatch();

  const {
    downloadPath,
    currentIdentifier,
  } = useSelector((state) => state.healthSummary)
  const { patientId } = useSelector((state) => state.profile.patient);

  const canTriggerButton = (event) => (
    event &&
    (event.type === 'click' ||
    (event.type === 'keypress' &&
      (event.charCode === 13 || event.keyCode === 13)))
  );

  const handleDownload = (event) => {
    if (canTriggerButton(event)) {
      dispatch(setDownloadPath(patientId, currentIdentifier));
    }
  }

  const handleDownloadComplete = () => {
    dispatch(setDownloadPath());
  }

  return (
    <>
      <a type="button" className="btn btn-outline-secondary me-1 mb-1" tabIndex="0"
        data-qa-item="DownloadButton"
        onClick={ handleDownload }
        onKeyPress={ handleDownload }
        role="button"
        aria-describedby="downloadMessage"
      >
        <span className="fa-solid fa-cloud-arrow-down mr-1"></span>
        <FormattedMessage {...messages.page.download} />
      </a>
      {
        downloadPath === null || downloadPath === undefined ? null :
          <FileDownload
            onDownloadComplete={handleDownloadComplete}
            actionPath={downloadPath}
          />
      }
    </>
  );
}

export default FileDownloadButton;